import { PartnerManagementResponseModel } from "api/repositories/partnerManagement/model/PartnerManagementResponseModel";
import { BaseFilterListResponseModel } from "app/based/baseApiModel/baseFilterListModel/BaseFilterListResponseModel";
import { AssetsClassify } from "utils/enums/AssetClassify";
import { BaseUserAddressModel } from "./userAddress/BaseUserAddressModel";
import { BaseUserItemResponseModel } from "./userItem/BaseUserItemResponseModel";
import { StoreResponseModel } from "features/storeManagement/data/model/StoreResponseModel";

export class AssetsModel {
  id?: string;
  code?: string;
  classify?: AssetsClassify;
  url?: string;
  order?: number;
  title?: string;
}

export class UserAddressModel {
  district?: BaseUserAddressModel;
  province?: BaseUserAddressModel;
  ward?: BaseUserAddressModel;
  full?: string;
}

export class AppInfoModel {
  createdAt?: string;
  appVersion?: string;
  appBuildNumber?: string;
  appOS?: string;
  lastLoginTime?: string;
  location?: string;
  ip?: string;
}

export class UserBankInfoModel {
  id?: number;
  name?: string;
  code?: string;
  bin?: string;
  shortName?: string;
  logo?: string;
  transferSupported?: number;
  lookupSupported?: number;
  short_name?: string;
  support?: number;
  isTransfer?: number;
  swift_code?: string;
}

export class ParticipantModel {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  code?: string;
  recipentCode?: number;
  phoneNumber?: string;
  type?: number; // 0: Sigle customer, 1: Organization
  status?: number; // 0: Init, 1: Processing, 2: Signed, 3: Expried
  user?: string;
  contract?: string;
  files?: AssetsModel[];
  taxCode?: string;
  bankAccount?: string;
  bankName?: string;
  bankInfo?: UserBankInfoModel;
  fullName?: string;
  email?: string;
  idNumber?: string;
  idIssueDate?: string;
  idIssuePlace?: string;
  addressDetails?: UserAddressModel;
}

export class OrganizationModel {
  name?: string;
  address?: string;
  email?: string;
  taxCode?: string;
  bankAccount?: string;
  bankName?: string;
  bankInfo?: UserBankInfoModel;
  representativeName?: string;
  representativeRole?: string;
  businessCerts?: AssetsModel[];
  addressDetails?: UserAddressModel;
}

export class WalletOfUser {
  balance?: number;
  currency?: number;
}

export abstract class BaseUserResponseModel {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  code?: string;
  providerCode?: number;
  providerPreviewCode?: string;
  type?: number;
  status?: number;
  expriedSignDate?: string;
  expriedAt?: string;
  isVerified?: boolean;
  organization?: OrganizationModel;
  template?: string;
  participants?: ParticipantModel[];
  userContracts?: ParticipantModel[];
  file?: AssetsModel;
  reason?: string;
  approvedBy?: BaseUserResponseModel;
  features?: BaseFilterListResponseModel[];
  note?: string;
  order?: string;
  username?: string;
  phone?: string;
  email?: string;
  isValidIp?: boolean;
  configuration?: any;
  role?: BaseFilterListResponseModel;
  avatar?: any;
  userName?: string;
  fullName?: string;
  address?: string;
  description?: string;
  wallet?: WalletOfUser;
  partner?: PartnerManagementResponseModel;
  store?: Array<StoreResponseModel>;
  parent?: BaseUserResponseModel;
  latestContract?: BaseUserResponseModel;
  listAppInfo?: AppInfoModel[];
  users?: Array<BaseUserItemResponseModel>;

  constructor(data?: Partial<BaseUserResponseModel>) {
    Object.assign(this, data || {});
  }
}
